import React from 'react'
import styled, { keyframes } from 'styled-components'
const NoFavoritesContainer = styled.div`
    font-family: 'nexablack', sans-serif;
    line-height: 30px;
    font-size: 24px;
    -webkit-font-smoothing: antialiased;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    margin-top: 20px;
`
const BigText = styled.div`
    font-size: 36px;
    margin-bottom: 10px;
`
const BigHeart = styled.div`
    height: 50px;
    margin: 12px auto;
    position: relative;
    width: 60px;
`
const beat = keyframes`
 0% {
        opacity: 1;
        transform: scale(1.2);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`
const BigHeartImg = styled.img`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    animation: ${beat} 1s cubic-bezier(0.165, 0.84, 0.44, 1) 0s infinite;
`
const BigHeartImgAlt = styled(BigHeartImg)`
    animation-delay: 0.25s;
    animation-fill-mode: forwards;
`
const NoFavorites = () => (
    <NoFavoritesContainer>
        <BigText>
            <span>Go</span>
            <BigHeart>
                <BigHeartImg src="/static/img/svg/heart.svg" alt="" />
                <BigHeartImgAlt src="/static/img/svg/heart.svg" alt="" />
            </BigHeart>
            <span>GIFs.</span>
        </BigText>
        <span>They&apos;ll save here!</span>
    </NoFavoritesContainer>
)

export default NoFavorites
